<template>
    <div class="flex items-center h-12">
        <template v-if="!isAlreadySending">
            <DoubleButton text="Send Request" icon="sr-2 sr-v2-pencil"
                :color="color"
                @left="send()"
                @right="startEditing()"
                no-border
            />
        </template>

        <Modal :show="isEditing"
            :athleteName="athleteName"
            @confirm="onEditConfirm()"
            @cancel="onEditCancel()"
            v-model="messageBody"
        />
    </div>
</template>

<script>
import Modal from './Modal'
import DoubleButton from '@/components/DoubleButton'
import Spinner from '@/components/Spinner'
import api from '@/services/api'
import uniqBy from 'lodash/uniqBy'
import { mapActions, mapGetters } from 'vuex'

const cleanMessage = message => message
    .replace(/^\n/, '')
    .replace(/^(\t| )+/gm, '')
    .replace(/[^\n]\n[^\n]/gm, s => s.replace('\n', ' '))
    .replace(/\n+$/, '')

export default {
    components: {
        Modal,
        DoubleButton,
        Spinner,
    },

    props: {
        color: { type: String, default: 'blue' },
        type: { type: String, required: true },
        makeDefaultMessage: { type: Function, required: true },
        source: { type: String, required: false },
    },

    data() {
        return {
            messageBody: '',
            isEditing: false
        }
    },

    computed: {
        ...mapGetters('athleteProfile', {
            isAlreadySending: 'isSendingFeedbackRequest',
            athleteName: 'firstName',
            organizations: 'organizations',
            teams: 'teams',
            athleteGender: 'gender',
        }),

        ...mapGetters('userData', {
            coachName: 'firstName'
        }),

        chosenOrganization() {
            return this.organizations[0]
        },

        staves() {
            return uniqBy([
                ...this.chosenOrganization.staff.filter(staff => staff.isAdmin),
                ...this.teams.filter(team => team.organization.id === this.chosenOrganization.id)
                    .map(team => team.staffAffiliations)
                    .reduce((allStaves, affiliations) => {
                        return [
                            ...allStaves,
                            ...affiliations.map(a => a.staff)
                        ]
                    }, [])
            ], 'id')
        },

        staffNames() {
            return this.staves.map(staff => staff.firstName)
        },

        defaultMessage() {
            const message = this.makeDefaultMessage({
                coachName: this.coachName,
                staffNames: this.staffNames,
                athleteName: this.athleteName,
                athleteGender: this.athleteGender,
            })

            return cleanMessage(message)
        },
    },

    created() {
        this.resetMessage()
    },

    methods: {
        ...mapActions('athleteProfile', ['sendFeedbackRequest']),

        async send() {
            await this.sendFeedbackRequest({
                type: this.type,
                body: this.messageBody,
                organization: this.chosenOrganization,
                source: this.source,
            })
        },

        startEditing() {
            this.isEditing = true
        },

        onEditConfirm() {
            this.send()
            this.isEditing = false
        },

        onEditCancel() {
            this.resetMessage()
            this.isEditing = false
        },

        resetMessage() {
            this.messageBody = this.defaultMessage
        },
    }
}
</script>